module.exports = __webpack_public_path__ + "media/styles/images/svg/eraser-gray-dark-24e844bb5f5d78aacc4f99fcc05d138b.svg";